import {CampaignSignal} from 'common/src/modules/excelToCampaign/excelToCampaign.types';
import {ColumnToSignalMapping} from '../../../excelToCampaignAgent.types';
import {MappingValidationError} from '../validateMappingsTool.types';

function validateMandatorySignals({
  allSignals,
  mappings,
}: {
  allSignals: CampaignSignal[];
  mappings: ColumnToSignalMapping[];
}): MappingValidationError[] {
  const issues: MappingValidationError[] = [];

  const mandatorySignals = allSignals.filter((signal) => signal.isMandatory);
  const missingMandatorySignals = mandatorySignals.filter((mandatorySignal) =>
    mappings.every((mapping) => mapping.signalKey !== mandatorySignal.signalKey),
  );

  if (missingMandatorySignals.length > 0) {
    const message = `Missing mandatory column(s): ${missingMandatorySignals.join(', ')}. 
    Please update the excel file and upload it again.`;

    issues.push({messageToUser: message, instructionsForAgent: ''});
  }

  return issues;
}

export default validateMandatorySignals;
